import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import { apiUrl, adminlimit } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  showStatus,
  encodeValue,
  removeItem,
  checkPermission,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "shipto/";
var moduleName = "Ship To";
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + "shipto/list",
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push({
      pathname: "/shipto/edit",
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID) {
    var params = { delete_id: deleteID };
    var delurl = module + "delete";
    removeItem(params, delurl, this.sateValChange, this.state.currentPage);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="customer" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    {checkPermission("customer", "add") === true && (
                      <div>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to={"/" + module + "add"}>
                              <button
                                className="btn btn-sm btn-success badge"
                                type="button"
                              >
                                <i className="fa fa-plus"></i> Add New
                              </button>
                            </Link>
                          </li>
                        </ol>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Search " + moduleName}
                                name="name"
                                onChange={this.handleChangeText}
                                value={this.state.name}
                              />
                            </div>

                            <div className="col-md-2">
                              <Select
                                value={this.state.status}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "status"
                                )}
                                placeholder="Select Status"
                                isClearable={true}
                                options={[
                                  { value: "A", label: "Active" },
                                  { value: "I", label: "In Active" },
                                ]}
                              />
                            </div>
                            <div className="col-md-3">
                              <a
                                href={() => false}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={() => false}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Contact Person</th>
                                      <th>Mobile </th>
                                      <th>Email</th>
                                      <th>Address</th>
                                      <th>Branch</th>
                                      <th>GST No.</th>
                                      <th>GST Code</th>
                                      <th>Status</th>
                                      {(checkPermission("customer", "edit") ===
                                        true ||
                                        checkPermission(
                                          "customer",
                                          "delete"
                                        ) === true) && (
                                        <th className="text-center">Actions</th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{item.customerName}</td>
                                            <td>
                                              {item.customerContactPerson}
                                            </td>
                                            <td>{item.customerMobile}</td>
                                            <td>{item.customerEmail}</td>
                                            <td>
                                              {item.customerAddress1}
                                              {item.customerAddress2 !== "" &&
                                                item.customerAddress2 !==
                                                  null && (
                                                  <>, {item.customerAddress2}</>
                                                )}

                                              {item.customerState !== "" &&
                                                item.customerState !== null && (
                                                  <>
                                                    , <br />
                                                    {item.customerState}
                                                  </>
                                                )}
                                              {item.customerPincode !== "" &&
                                                item.customerPincode !==
                                                  null && (
                                                  <> - {item.customerPincode}</>
                                                )}
                                            </td>
                                            <td>{item.customerBranch}</td>
                                            <td>{item.customerGSTNo}</td>
                                            <td>{item.customerGSTCode}</td>
                                            <td>
                                              {showStatus(item.customerStatus)}
                                            </td>
                                            {(checkPermission(
                                              "customer",
                                              "edit"
                                            ) === true ||
                                              checkPermission(
                                                "customer",
                                                "delete"
                                              ) === true) && (
                                              <td className="text-center text-nowrap align-middle">
                                                {checkPermission(
                                                  "customer",
                                                  "edit"
                                                ) === true && (
                                                  <a
                                                    href={() => false}
                                                    onClick={this.edit.bind(
                                                      this,
                                                      item.customerID
                                                    )}
                                                    className="me-2"
                                                  >
                                                    <i className="fa fa-pencil-square-o"></i>
                                                  </a>
                                                )}
                                                {checkPermission(
                                                  "customer",
                                                  "delete"
                                                ) === true && (
                                                  <a
                                                    href={() => false}
                                                    className="delete_record"
                                                    data="Delete"
                                                    onClick={this.removeItem.bind(
                                                      this,
                                                      encodeValue(
                                                        item.customerID
                                                      )
                                                    )}
                                                  >
                                                    <i className="fa fa-trash"></i>
                                                  </a>
                                                )}
                                              </td>
                                            )}
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td className="text-center" colSpan={8}>
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              
                                <Pagenation
                                  params={{
                                    totalRecords: this.state.totalRecords,
                                    totalPage: this.state.totalPage,
                                    currentPage: this.state.currentPage,
                                  }}
                                  sateValChange={this.sateValChange}
                                />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
